import * as React from "react";
import {useState} from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import {
  Autocomplete,
  Box,
  Button,
  CardActionArea,
  CardActions,
  Container,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
} from "@mui/material";

import { useParams } from "react-router-dom";
import { useGetBureauQuery,useGetAllBureausQuery } from "../../app/services/bureauApi";
import { useGetCourQuery } from "../../app/services/courApi";
import Loader from "../loader/Loader";
import DeviseList from "../devise/DeviseList";
import CoursTable from "./CoursTable";
import CoursCard from "./CoursCard";
import HistoriqueTable from "./HistoriqueTable";


export default function HistoriqueCour() {
  const [bureauId, setBureauId] = useState(1);
  const [errorMessage, setErrorMessage] = useState("");
  // const {id}=useParams();
  // const id=1;
  const { data, isLoading, isSuccess, isError, error } = useGetCourQuery(bureauId);
  const { data: bureaus, isLoading: isBureausLoading } = useGetAllBureausQuery();
  const cours=data?.bureau?.cours;
  const members = bureaus?.map((bureau) => (
    <MenuItem key={bureau.id} value={bureau.id}>
      
      <Stack direction="column" spacing={0.5}>
        <Typography variant="subtitle1" fontWeight="bold">
          {bureau.nom}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {bureau.quartier}
        </Typography>
      </Stack>
    </MenuItem>
  ));
  const handleChangeBureau = (event) => {
    setBureauId(event.target.value);
    setErrorMessage("");
  };

  if (isLoading) {
    return <Loader />;
  }
  console.log("dataaa:" , data);

  return (
    <Container maxWidth="xl" sx={{ backgroundColor: "#ffff8d", pt: 0, pb: 2 }}>
          <Typography variant="h5">Historique des cours de devises</Typography>
      <Typography paragraph>
        Afficher l'historique des mises à jours des prix d'achat et de vente de
        devises.
      </Typography>
    <Stack>

    
        <Stack
          direction={{ xs: "column", md: "row" }}
          spacing={3}
          justifyContent="center"
          alignItems="stretch"
          sx={{ p: 2, flexWrap: "wrap" }}
        >
          {/* Carte de recherche */}
          <Card
            sx={{
              flex: 1,
              minWidth: 280,
              backgroundColor: "#fffde7",
              border: "1px solid #fdd835",
              boxShadow: 3,
              borderRadius: 3,
            }}
          >
            <CardContent>
              <Typography variant="h6" component="div" gutterBottom>
                Recherche de bureau
              </Typography>

              <FormControl fullWidth variant="outlined">
                <InputLabel id="bureau-label">
                  Bureau de change & quartier
                </InputLabel>
                <Select
                  labelId="bureau-label"
                  id="bureau-select"
                  label="Bureau de change & quartier"
                  // value={selectedBureau}
                  onChange={handleChangeBureau}
                >
                  {members}
                </Select>
              </FormControl>
            </CardContent>
          </Card>

          {/* Carte d'infos bureau */}
          <Card
            sx={{
              flex: 2,
              maxWidth: 800,
              minWidth: { xs: "100%", md: 400 },
              boxShadow: 3,
              borderRadius: 3,
              border: "1px solid #ddd",
              mt: { xs: 3, md: 0 },
            }}
          >
            <CardContent>
              <Box sx={{ mb: 2 }}>
                <Typography variant="h5" sx={{ fontWeight: "bold" }}>
                  {data.Bureau.nom}
                </Typography>
                <Typography variant="subtitle1" color="text.secondary">
                  {data.Bureau.quartier}
                </Typography>
              </Box>

              <Typography variant="body2" color="text.secondary" gutterBottom>
                📍 {data.Bureau.adresse}
              </Typography>
              <Typography variant="body2" color="text.secondary" gutterBottom>
                📞 {data.Bureau?.telephone}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                ✉️ {data.Bureau?.email}
              </Typography>
            </CardContent>
          </Card>
        </Stack>
{/* <CoursTable bureauId={data?.Bureau?.id}/> */}
<HistoriqueTable cours={data?.Bureau?.cours}/>
</Stack>
</Container>

  );
}

